import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from './authApi';
import { setUser } from './authSlice';
import { persistAuthTokens } from '../../services/authTokens';

const { Title, Text } = Typography;

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const result = await login(values);
      persistAuthTokens(result);
      dispatch(setUser(result.user));
      message.success('Welcome back!');
      navigate(from);
    } catch (err) {
      message.error(err.response?.data?.title || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="df-auth-shell">
      <div className="df-auth-panel">
        <div className="df-auth-panel__inner">
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <div className="df-brand df-brand--dark" style={{ justifyContent: 'center', marginBottom: 18 }}>
              <span className="df-brand__mark" aria-hidden="true">DF</span>
              <span className="df-brand__wordmark">DealFusion</span>
            </div>
            <Title level={3} style={{ margin: 0, fontFamily: 'var(--df-font-display)' }}>
              Welcome back
            </Title>
            <Text style={{ fontSize: 14, marginTop: 6, display: 'block', color: 'var(--df-text-secondary)' }}>
              Sign in for alerts, saves, and community heat.
            </Text>
          </div>

          <Form layout="vertical" onFinish={handleSubmit} size="large" requiredMark={false}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Enter your email' },
                { type: 'email', message: 'Invalid email format' },
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ color: 'var(--df-text-muted)' }} />}
                placeholder="you@email.com"
                style={{ borderRadius: 8, height: 44 }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Enter your password' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: 'var(--df-text-muted)' }} />}
                placeholder="Your password"
                style={{ borderRadius: 8, height: 44 }}
              />
            </Form.Item>

            <div style={{ textAlign: 'right', marginBottom: 16 }}>
              <Link to="/forgot-password" style={{ fontSize: 13, fontWeight: 600, color: 'var(--df-primary)' }}>
                Forgot password?
              </Link>
            </div>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
                style={{
                  borderRadius: 8,
                  height: 46,
                  fontWeight: 600,
                  background: 'var(--df-accent)',
                  borderColor: 'var(--df-accent)',
                }}
              >
                Sign In
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <Text style={{ fontSize: 13, color: 'var(--df-text-secondary)' }}>
              Don&apos;t have an account?{' '}
              <Link to="/register" style={{ fontWeight: 700, color: 'var(--df-primary)' }}>Sign up</Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
